/* file description */
import React from 'react';
import { getDictByRequest } from '@/common/system-apis/getDictByRequest';
import { SELECT_MODE, VALUE_TYPES, COLUMN_FROM } from '../consts';
import { TransformNalmalType2TableColumn } from '../type';
import UserSelectMemo from '../../component/UserSelect';
import { Api as FetchAPI } from '@/utils';

export const transformBoulderaiUser2TableColumn: TransformNalmalType2TableColumn = ({
  targetColumn,
  field,
  moduleInfo,
  isMobile,
}) => {
  // 是否可以多选
  const isMulti = !!field.isMulti;

  targetColumn.valueType = VALUE_TYPES.SELECT;

  if (isMulti) {
    targetColumn.fieldProps = {
      mode: SELECT_MODE.MULTIPLE,
    };
  }

  if (FetchAPI) {
    const { parentField, userList } = field?.bizConfig || {};
    if (parentField) {
      targetColumn.dependencies = [parentField];
    }
    targetColumn.renderFormItem = (_a, config, form) => {
      return <UserSelectMemo moduleInfo={moduleInfo} form={form} config={config} field={field} columnFrom={config.from} FetchAPI={FetchAPI} isMobile={isMobile} />;
    };
    targetColumn.render = (dom, entity) => {
      const targerValue = entity?.value;
      const findDictItem = userList?.find((item: Record<any, any>) => item.userAccount === targerValue) || {};
      return findDictItem.userName || targerValue;
    };
  } else {
    // const interfaceId = '262985367836165068';

    // const parameter = {
    //   roleId: field?.options?.roleId ?? '',
    //   deptId: field?.options?.depId ?? '',
    // };
    // targetColumn.request = async () => {
    //   try {
    //     const res = await getDictByRequest({ interfaceId, parameter, SystemAPI });
    //     const resData = JSON.parse(res);
    //     const data = resData ?? [];
    //     return data.map((user: { userAccount: string; userName: string }) => ({
    //       value: user.userAccount,
    //       label: user.userName,
    //     }));
    //   } catch (error) {
    //     console.error(error);
    //     return [];
    //   }
    // };
  }
  return targetColumn;
};
